export const appSettingsApiSettingsInfoDatatableAppGroupId =
  "/app_settings/api_settings_info_datatable(/:app_group_id)";
